/* Online report viewer (cardiagons.com/pages/report?t=<token>).
   Shows the saved report pages (same HTML + cardiagnos-report.css as the
   PDF) scaled to the screen. Tapping a photo opens a popup with only the
   photos from that same page (swipe / arrows between them); tapping outside,
   ✕ or Esc closes it. The PDF stays downloadable from the top bar. */
(function(){
  'use strict';
  var CFG = window.CI_REPORT_VIEWER || {};
  var STR = {
    en: { preparing: 'Preparing photos…', pdf: 'Download PDF', hint: 'Tap any photo to see it larger', loading: 'Loading report…', missing: 'This report link is invalid or no longer available.', close: 'Close', hide:'Hide information', hideTitle:'Hide information', hidePersonal:'Customer details', hidePersonalNote:'Hides the name, email and phone number.', hideVehicle:'VIN and plate number', hideVehicleNote:'Hides the chassis number (VIN) and the plate number, and covers licence plates in the photos and videos automatically.', platesWait:'Plates in the photos are still being detected. This can take a minute. Reopen this panel shortly, or cover a plate yourself by tapping the photo.', videoBlocked:'This video cannot be shown while plates are hidden, because its plate detection is not ready yet. Try again in a few minutes.', hidePhotoNote:'To hide a plate in a photo: tap the photo, choose \u201cCover with a box\u201d and drag over the plate.', hideInfo:'Hidden details are replaced by black blocks. They are removed from the PDF you save, not just covered.', pdfHidden:'Download PDF (hidden)', print:'Save as PDF', cover:'Cover with a box', undo:'Undo box', coverHelp:'Drag over the part to hide', coverFail:'This photo cannot be edited here.', done:'Done', hiddenOn:'Hidden version' },
    ar: { preparing: 'جارٍ تجهيز الصور…', pdf: 'تنزيل PDF', hint: 'اضغط على أي صورة لتكبيرها', loading: 'جارٍ تحميل التقرير…', missing: 'رابط التقرير غير صالح أو لم يعد متاحًا.', close: 'إغلاق', hide:'إخفاء المعلومات', hideTitle:'إخفاء المعلومات', hidePersonal:'بيانات العميل', hidePersonalNote:'يخفي الاسم والبريد الإلكتروني ورقم الهاتف.', hideVehicle:'رقم الهيكل ورقم اللوحة', hideVehicleNote:'يخفي رقم الهيكل (VIN) ورقم اللوحة، ويغطي لوحات السيارات في الصور والفيديوهات تلقائيًا.', platesWait:'ما زال يجري اكتشاف اللوحات في الصور. قد يستغرق دقيقة. افتح هذه اللوحة بعد قليل، أو غطِّ اللوحة بنفسك بالضغط على الصورة.', videoBlocked:'لا يمكن عرض هذا الفيديو أثناء إخفاء اللوحات لأن اكتشاف اللوحات فيه لم يكتمل بعد. حاول بعد بضع دقائق.', hidePhotoNote:'لإخفاء اللوحة في صورة: اضغط على الصورة ثم «تغطية بمربع» واسحب فوق اللوحة.', hideInfo:'تُستبدل البيانات المخفية بمربعات سوداء، وتُزال من ملف PDF الذي تحفظه ولا تُغطى فقط.', pdfHidden:'تنزيل PDF (مخفي)', print:'حفظ كملف PDF', cover:'تغطية بمربع', undo:'تراجع عن المربع', coverHelp:'اسحب فوق الجزء المراد إخفاؤه', coverFail:'لا يمكن تعديل هذه الصورة هنا.', done:'تم', hiddenOn:'نسخة مخفية' },
    sv: { preparing: 'Förbereder bilder…', pdf: 'Ladda ner PDF', hint: 'Tryck på en bild för att se den större', loading: 'Laddar rapporten…', missing: 'Rapportlänken är ogiltig eller inte längre tillgänglig.', close: 'Stäng', hide:'Dölj uppgifter', hideTitle:'Dölj uppgifter', hidePersonal:'Kunduppgifter', hidePersonalNote:'Döljer namn, e-post och telefonnummer.', hideVehicle:'Chassinummer och registreringsnummer', hideVehicleNote:'Döljer chassinumret (VIN) och registreringsnumret, och täcker registreringsskyltar i foton och videor automatiskt.', platesWait:'Skyltarna i fotona identifieras fortfarande. Det kan ta en minut. Öppna panelen igen om en stund, eller täck en skylt själv genom att trycka på fotot.', videoBlocked:'Den här videon kan inte visas medan skyltar är dolda, eftersom skyltidentifieringen inte är klar än. Försök igen om några minuter.', hidePhotoNote:'Så döljer du en skylt på ett foto: tryck på fotot, välj \u201dTäck över med en ruta\u201d och dra över skylten.', hideInfo:'Dolda uppgifter ersätts av svarta block. De tas bort ur PDF:en du sparar, de täcks inte bara över.', pdfHidden:'Ladda ner PDF (dold)', print:'Spara som PDF', cover:'Täck över med en ruta', undo:'Ångra ruta', coverHelp:'Dra över det som ska döljas', coverFail:'Det här fotot kan inte redigeras här.', done:'Klar', hiddenOn:'Dold version' },
  };
  var SHADOW_VARS = ':host{--brand:#1a4fd6;--brand-dark:#0e2f8f;--brand-light:#eaf1ff;--brand-lighter:#f5f8ff;'
    + '--ink:#0f1729;--muted:#5b6478;--faint:#8b93a7;--line:#e3e7f0;--line-soft:#eef1f7;'
    + '--ok:#178a4c;--ok-bg:#e8f7ee;--warn:#b26a00;--warn-bg:#fdf1de;--bad:#c22a2a;--bad-bg:#fdeaea;'
    + '--page-w:210mm;--page-content-w:calc(210mm - 32mm);--page-h:297mm;}'
    + '.report-root{display:block}'
    + '.crv-scale{position:absolute;left:0;top:0;transform-origin:0 0}' // pinned left: RTL reports otherwise shift out of view
    + '.photo-slot img,.snap-photo img{cursor:zoom-in}'
    + 'a.video-open-btn{cursor:pointer}';

  var statusEl = document.getElementById('crvStatus');
  var pagesEl = document.getElementById('crvPages');
  var titleEl = document.getElementById('crvTitle');
  var pdfEl = document.getElementById('crvPdf');
  var hintEl = document.getElementById('crvHint');
  var loaderEl = document.getElementById('crvLoader');
  var loadTextEl = document.getElementById('crvLoadText');
  var barEl = document.getElementById('crvProgressBar');
  if(!pagesEl) return;
  function loadText(t){ if(loadTextEl) loadTextEl.textContent = t; }
  function progress(f){
    if(!barEl) return;
    barEl.classList.add('crv-known');
    barEl.style.marginLeft = '0';
    barEl.style.width = Math.max(4, Math.min(100, Math.round(f * 100))) + '%';
  }
  function hideLoader(){
    if(!loaderEl) return;
    progress(1);
    loaderEl.classList.add('crv-done');
    setTimeout(function(){ loaderEl.style.display = 'none'; }, 380);
  }
  function fail(){
    if(loaderEl) loaderEl.style.display = 'none';
    statusEl.style.display = ''; statusEl.textContent = S.missing;
  }

  var token = new URLSearchParams(location.search).get('t') || '';
  var guessLang = (document.documentElement.lang || 'en').slice(0, 2);
  var S = STR[guessLang] || STR.en;
  loadText(S.loading);

  // robots: these links are private
  try{ var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); }catch(e){}

  function sanitize(root){
    root.querySelectorAll('script,iframe,object,embed,link,meta,base,form,noscript').forEach(function(n){ n.remove(); });
    root.querySelectorAll('*').forEach(function(el){
      Array.prototype.slice.call(el.attributes).forEach(function(a){
        var n = a.name.toLowerCase();
        if(n.indexOf('on') === 0) el.removeAttribute(a.name);
        else if((n === 'href' || n === 'src' || n === 'xlink:href') && /^\s*javascript:/i.test(a.value)) el.setAttribute(a.name, '#');
        else if((n === 'src' || n === 'href') && /^\/\//.test(a.value)) el.setAttribute(a.name, 'https:' + a.value);
      });
    });
  }

  var reviewKey = '';
  try{ reviewKey = (new URLSearchParams(location.search)).get('k') || ''; }catch(e){}
  function pendingMsg(t){
    var ar = /^\/ar(\/|$)/.test(location.pathname) || document.documentElement.lang === 'ar';
    var sv = document.documentElement.lang === 'sv';
    var msg = ar ? 'هذا التقرير بانتظار إصداره وسيكون متاحًا قريبًا.' : sv ? 'Rapporten väntar på att släppas och blir snart tillgänglig.' : (t || 'This report is waiting to be released and will be available shortly.');
    document.body.innerHTML = '<div style="max-width:420px;margin:15vh auto;padding:28px;text-align:center;font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#0f1729;background:#fff;border:1px solid #e3e7f0;border-radius:14px" dir="' + (ar ? 'rtl' : 'ltr') + '"><div style="font-size:40px">🔍</div><p style="font-size:16px;line-height:1.6;margin:12px 0 0">' + msg + '</p></div>';
  }
  if(!/^[A-Za-z0-9]{16,64}$/.test(token)){ fail(); return; }

  // Download with a real progress bar (the report carries its photos).
  fetch(CFG.workerUrl.replace(/\/$/, '') + '/report-view/' + token + (reviewKey ? '?k=' + encodeURIComponent(reviewKey) : ''))
    .then(function(r){
      if(!r.ok) throw new Error('not found');
      var total = +r.headers.get('Content-Length') || 0;
      if(!r.body || !r.body.getReader || !total) return r.json();
      var reader = r.body.getReader(), got = 0, chunks = [];
      function pump(){
        return reader.read().then(function(res){
          if(res.done){
            var all = new Uint8Array(got), off = 0;
            chunks.forEach(function(c){ all.set(c, off); off += c.length; });
            return JSON.parse(new TextDecoder().decode(all));
          }
          chunks.push(res.value); got += res.value.length;
          progress(0.9 * got / total);
          return pump();
        });
      }
      return pump();
    })
    .then(function(doc){ if(doc && doc.pending){ pendingMsg(doc.error); return; } render(doc); })
    .catch(fail);

  function render(doc){
    S = STR[doc.lang] || STR.en;
    if(doc.forceHide && !(doc.plates && doc.plates.imagesDone)){
      pendingMsg(doc.lang === 'ar' ? 'نجهّز هذا التقرير وفق إعدادات الخصوصية. يرجى إعادة المحاولة بعد دقيقة.' : doc.lang === 'sv' ? 'Rapporten förbereds enligt sekretessinställningarna. Försök igen om en minut.' : 'This report is being prepared with privacy settings applied. Please try again in a minute.');
      setTimeout(function(){ location.reload(); }, 25000);
      return;
    }
    loadText(S.preparing);
    var rtl = doc.dir === 'rtl';
    document.title = doc.title || document.title;
    titleEl.textContent = doc.title || '';
    if(rtl){ document.getElementById('crvRoot').setAttribute('dir', 'rtl'); }
    if(doc.pdfUrl && /^https:\/\//i.test(doc.pdfUrl)){ pdfEl.href = doc.pdfUrl; pdfEl.textContent = S.pdf; pdfEl.style.display = ''; }
    hintEl.textContent = S.hint; hintEl.style.display = '';

    var host = document.createElement('div');
    // The theme hides every empty <div> (div:empty{display:none}), and a
    // shadow host always counts as empty -- force it visible.
    host.style.display = 'block';
    host.style.minHeight = '1px';
    pagesEl.appendChild(host);
    var shadow = host.attachShadow({ mode: 'open' });
    var link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = CFG.reportStylesheetUrl;
    shadow.appendChild(link);
    var vars = document.createElement('style'); vars.textContent = SHADOW_VARS; shadow.appendChild(vars);

    var tpl = document.createElement('template');
    tpl.innerHTML = doc.pagesHtml || '';
    sanitize(tpl.content);
    var root = document.createElement('div');
    root.className = 'report-root' + (rtl ? ' rtl' : '');
    root.setAttribute('dir', rtl ? 'rtl' : 'ltr');
    shadow.appendChild(root);

    // One scaled wrapper per page so every page fits the screen width.
    var pages = Array.prototype.slice.call(tpl.content.querySelectorAll('.page'));
    var wraps = pages.map(function(pg){
      var wrap = document.createElement('div'); wrap.className = 'crv-page-wrap';
      var inner = document.createElement('div'); inner.className = 'crv-scale';
      inner.appendChild(pg);
      wrap.appendChild(inner);
      root.appendChild(wrap);
      return { wrap: wrap, inner: inner, page: pg };
    });
    var extra = document.createElement('style');
    extra.textContent = '.crv-page-wrap{position:relative;margin:0 auto 14px;box-shadow:0 4px 18px rgba(14,27,61,.12);border-radius:6px;overflow:hidden;background:#fff}';
    shadow.appendChild(extra);

    function fit(){
      var avail = Math.min(pagesEl.clientWidth || window.innerWidth, 860);
      wraps.forEach(function(w){
        var pw = w.page.offsetWidth || 794, ph = w.page.offsetHeight || 1123;
        var s = Math.min(1, avail / pw);
        w.inner.style.transform = 'scale(' + s + ')';
        w.inner.style.width = pw + 'px';
        w.wrap.style.width = (pw * s) + 'px';
        w.wrap.style.height = (ph * s) + 'px';
      });
    }
    // Reveal once the styles are in and the first page's images decoded.
    var revealed = false;
    function reveal(){ if(revealed) return; revealed = true; fit(); hideLoader(); }
    link.onload = function(){
      fit();
      var firstImgs = pages[0] ? Array.prototype.slice.call(pages[0].querySelectorAll('img')) : [];
      Promise.all(firstImgs.map(function(im){ return im.decode ? im.decode().catch(function(){}) : null; })).then(reveal);
    };
    link.onerror = reveal;
    setTimeout(reveal, 6000);
    setTimeout(fit, 50);
    window.addEventListener('resize', fit);

    setupHide(shadow, root, extra, rtl, doc);

    // Photo popups: only the photos of the page that was tapped.
    shadow.addEventListener('click', function(e){
      // Videos play in a popup too (the PDF keeps its link to the video).
      var vbtn = e.target && e.target.closest && e.target.closest('a.video-open-btn');
      if(vbtn){
        e.preventDefault();
        var card = vbtn.closest('.video-card');
        var nameEl = card && card.querySelector('.video-card-name');
        openVideo(vbtn.getAttribute('href'), nameEl ? nameEl.textContent.trim() : '', rtl);
        return;
      }
      var img = e.target && e.target.closest && e.target.closest('.photo-slot img, .snap-photo img');
      if(!img) return;
      var page = img.closest('.page');
      var imgs = Array.prototype.slice.call(page.querySelectorAll('.photo-slot img, .snap-photo img'));
      openLightbox(imgs.map(function(im){
        var cell = im.closest('.extra-photo-report-cell');
        var capEl = cell && cell.querySelector('.extra-photo-report-desc');
        return { el: im, src: im.getAttribute('src'), cap: im.getAttribute('data-cap') || (capEl ? capEl.textContent.trim() : '') };
      }), imgs.indexOf(img), rtl);
    });
  }


  /* ---- Hide information (for the customer too) ----
     Customer details and/or VIN + plate are replaced by black blocks in the
     page text itself (so the saved PDF has no hidden text underneath), and a
     plate in a photo can be covered with a box that is drawn into the image.
     The saved PDF then comes from the browser's own "Save as PDF". */
  var LABELS = {
    customer: ['full name', 'email', 'phone number', 'الاسم الكامل', 'البريد الإلكتروني', 'رقم الهاتف', 'fullständigt namn', 'e-post', 'telefonnummer'],
    vehicle: ['vin / chassis no.', 'plate number', 'رقم الهيكل (vin)', 'رقم اللوحة', 'chassinummer (vin)', 'registreringsnummer']
  };
  var ORIG = new Map();
  function blocks(t){ return t.replace(/[^\s]/g, '█'); }
  function maskNode(n){ if(!ORIG.has(n)) ORIG.set(n, n.nodeValue); n.nodeValue = blocks(n.nodeValue); }
  function restoreAll(){ ORIG.forEach(function(v, n){ n.nodeValue = v; }); ORIG.clear(); }
  function textNodes(root){
    var out = [], w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    while(w.nextNode()) out.push(w.currentNode);
    return out;
  }

  /* ---- Automatic licence plates (boxes computed by the server) ---- */
  var PLATES = null, HIDE_PLATES = false, BURN_BUSY = [];
  function reportImgs(root){ return Array.prototype.slice.call(root.querySelectorAll('img')).filter(function(im){ return /^data:image\//.test(im.getAttribute('src') || ''); }); }
  function tagImgs(root){ reportImgs(root).forEach(function(im, n){ im.__pi = n; }); }
  function drawBoxes(src, boxes){
    return new Promise(function(resolve, reject){
      var im = new Image();
      im.onload = function(){
        try{
          var cv = document.createElement('canvas'); cv.width = im.naturalWidth; cv.height = im.naturalHeight;
          var c = cv.getContext('2d'); c.drawImage(im, 0, 0);
          c.fillStyle = '#000';
          boxes.forEach(function(b){ c.fillRect(b[0] * cv.width, b[1] * cv.height, b[2] * cv.width, b[3] * cv.height); });
          resolve(cv.toDataURL('image/jpeg', 0.92));
        }catch(e){ reject(e); }
      };
      im.onerror = reject; im.src = src;
    });
  }
  // Cover (or uncover) the plates the server found in each photo.
  function applyPlates(root, on){
    HIDE_PLATES = on;
    var jobs = [];
    reportImgs(root).forEach(function(im){
      var boxes = PLATES ? ((PLATES.images && PLATES.images[im.__pi]) || []).concat((PLATES.manual && PLATES.manual[im.__pi]) || []) : null;
      if(on && boxes && boxes.length && !im.__burnt){
        var before = im.getAttribute('src');
        jobs.push(drawBoxes(before, boxes).then(function(out){
          if(!HIDE_PLATES) return;
          im.__before = before; im.__burnt = out; im.setAttribute('src', out);
        }).catch(function(){}));
      }else if(!on && im.__burnt){
        if(im.getAttribute('src') === im.__burnt) im.setAttribute('src', im.__before);
        im.__burnt = null; im.__before = null;
      }
    });
    BURN_BUSY = jobs;
    return Promise.all(jobs);
  }
  function applyHide(root, on){
    restoreAll();
    ['customer', 'vehicle'].forEach(function(kind){
      if(!on[kind]) return;
      var vals = [];
      root.querySelectorAll('.info-row').forEach(function(row){
        var k = row.querySelector('.k'), v = row.querySelector('.v');
        if(!k || !v) return;
        if(LABELS[kind].indexOf(k.textContent.trim().toLowerCase()) === -1) return;
        var t = v.textContent.trim();
        if(t.length >= 3 && t !== '—') vals.push(t);
        textNodes(v).forEach(maskNode);
      });
      // The same words anywhere else (notes, captions...).
      if(vals.length){
        textNodes(root).forEach(function(n){
          if(ORIG.has(n)) return;
          var txt = n.nodeValue, low = txt.toLowerCase(), hit = false;
          vals.forEach(function(v){
            var lv = v.toLowerCase(), at = low.indexOf(lv);
            while(at !== -1){ txt = txt.slice(0, at) + blocks(v) + txt.slice(at + v.length); low = txt.toLowerCase(); hit = true; at = low.indexOf(lv, at + v.length); }
          });
          if(hit){ ORIG.set(n, n.nodeValue); n.nodeValue = txt; }
        });
      }
    });
  }
  function setupHide(shadow, root, extra, rtl, doc){
    PLATES = doc.plates || null; tagImgs(root);
    var hideBtn = document.getElementById('crvHideBtn'), panel = document.getElementById('crvHidePanel');
    var printBtn = document.getElementById('crvPrint');
    if(!hideBtn || !panel) return;
    // Print: only the report pages, one per A4 sheet, colours kept.
    extra.textContent += '@media print{.crv-page-wrap{width:210mm !important;height:297mm !important;margin:0 !important;box-shadow:none !important;border-radius:0 !important;break-after:page;page-break-after:always}'
      + '.crv-scale{position:static !important;transform:none !important;width:210mm !important}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}}';
    var pst = document.createElement('style');
    pst.textContent = '@media print{@page{size:A4;margin:0}body *{visibility:hidden}#crvPages,#crvPages *{visibility:visible}#crvPages{position:absolute;left:0;top:0;width:100%;margin:0}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}}';
    document.head.appendChild(pst);
    hideBtn.textContent = '🔒 ' + S.hide; hideBtn.style.display = '';
    var key = 'crv_hide_' + token, on = { customer: false, vehicle: false }, edited = false;
    var forced = !!doc.forceHide;
    try{ var saved = JSON.parse(localStorage.getItem(key) || 'null'); if(saved){ on.customer = !!saved.customer; on.vehicle = !!saved.vehicle; } }catch(e){}
    panel.innerHTML = '<div class="crv-hp-title">' + S.hideTitle + '</div>'
      + '<label class="crv-hp-row"><input type="checkbox" id="crvHideC"><span><b>' + S.hidePersonal + '</b><small>' + S.hidePersonalNote + '</small></span></label>'
      + '<label class="crv-hp-row"><input type="checkbox" id="crvHideV"><span><b>' + S.hideVehicle + '</b><small>' + S.hideVehicleNote + '</small></span></label>'
      + '<p class="crv-hp-note crv-hp-wait" style="display:none">' + S.platesWait + '</p>'
      + '<p class="crv-hp-note">' + S.hidePhotoNote + '</p>'
      + '<p class="crv-hp-note">' + S.hideInfo + '</p>';
    var cC = panel.querySelector('#crvHideC'), cV = panel.querySelector('#crvHideV');
    var waitEl = panel.querySelector('.crv-hp-wait'), pollTimer = null, polls = 0;
    function platesReady(){ return !!(PLATES && PLATES.imagesDone); }
    function pollPlates(){
      if(pollTimer || platesReady()) return;
      pollTimer = setInterval(function(){
        polls++;
        fetch(CFG.workerUrl.replace(/\/$/, '') + '/report-view/' + token + (reviewKey ? '?k=' + encodeURIComponent(reviewKey) : ''), { cache: 'no-store' })
          .then(function(r){ return r.json(); })
          .then(function(d){ if(d && d.plates){ PLATES = d.plates; doc.plates = d.plates; } if(platesReady() || polls > 40){ clearInterval(pollTimer); pollTimer = null; if(on.vehicle) refresh(); } })
          .catch(function(){});
      }, 15000);
    }
    function refresh(){
      applyHide(root, on);
      applyPlates(root, !!on.vehicle);
      if(waitEl){ waitEl.style.display = (on.vehicle && !platesReady()) ? '' : 'none'; if(on.vehicle && !platesReady()) pollPlates(); }
      var hidden = on.customer || on.vehicle || edited;
      hideBtn.classList.toggle('on', hidden);
      // Original PDF while nothing is hidden; the hidden version is saved through print.
      if(pdfEl) pdfEl.style.display = (!hidden && doc.pdfUrl && !forced) ? '' : 'none';
      if(printBtn){ printBtn.textContent = S.pdfHidden; printBtn.style.display = (hidden && !forced) ? '' : 'none'; }
      try{ localStorage.setItem(key, JSON.stringify(on)); }catch(e){}
    }
    if(forced){ on.customer = true; on.vehicle = true; hideBtn.style.display = 'none'; panel.style.display = 'none'; }
    cC.checked = on.customer; cV.checked = on.vehicle;
    cC.addEventListener('change', function(){ on.customer = cC.checked; refresh(); });
    cV.addEventListener('change', function(){ on.vehicle = cV.checked; refresh(); });
    hideBtn.addEventListener('click', function(){ panel.style.display = panel.style.display === 'none' || !panel.style.display ? 'block' : 'none'; });
    if(printBtn) printBtn.addEventListener('click', function(){ panel.style.display = 'none'; Promise.all(BURN_BUSY).then(function(){ setTimeout(function(){ window.print(); }, 50); }); });
    window.__crvPhotoChanged = function(){ edited = true; refresh(); };
    refresh();
  }

  // Videos stored in Cloudflare Stream play as HLS: Safari plays it natively, other browsers get hls.js.
  function streamHls(src){
    var m = /^https:\/\/(?:iframe\.)?videodelivery\.net\/([0-9a-f]{32})/i.exec(src || '');
    return m ? 'https://videodelivery.net/' + m[1] + '/manifest/video.m3u8' : null;
  }
  function loadHlsJs(cb){
    if(window.Hls){ cb(); return; }
    var s = document.createElement('script'); s.src = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.13/hls.min.js';
    s.onload = cb; s.onerror = cb; document.head.appendChild(s);
  }
  function attachVideoSource(v, src){
    var h = streamHls(src);
    if(!h){ v.src = src; return; }
    if(v.canPlayType('application/vnd.apple.mpegurl')){ v.src = h; return; }
    loadHlsJs(function(){
      if(window.Hls && window.Hls.isSupported()){ var hls = new window.Hls(); v.__hls = hls; hls.loadSource(h); hls.attachMedia(v); }
      else v.src = h;
    });
  }

  // Video popup: same look as the photo popup, with a real player.
  function openVideo(src, title, rtl){
    if(!src) return;
    var lb = document.createElement('div');
    lb.className = 'crv-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    if(rtl) lb.setAttribute('dir', 'rtl');
    lb.innerHTML = '<div class="crv-lb-card">'
      + '<button type="button" class="crv-lb-x" aria-label="' + S.close + '">✕</button>'
      + '<video class="crv-lb-img crv-lb-video" controls playsinline autoplay preload="metadata"></video>'
      + '<div class="crv-lb-cap"></div></div>';
    document.body.appendChild(lb);
    var v = lb.querySelector('video');
    var card = lb.querySelector('.crv-lb-card');
    var pv = PLATES && PLATES.videos && PLATES.videos[src];
    var stopOverlay = function(){};
    if(HIDE_PLATES){
      if(!pv || !pv.done || !pv.step){
        v.style.display = 'none';
        var msg = document.createElement('div'); msg.className = 'crv-lb-block'; msg.style.cssText = 'color:#fff;padding:40px 24px;font-size:15px;line-height:1.6;text-align:center';
        msg.textContent = S.videoBlocked; card.insertBefore(msg, v);
        v = null;
      }else{
        v.setAttribute('controlsList', 'nodownload nofullscreen'); v.setAttribute('disablePictureInPicture', ''); v.disablePictureInPicture = true;
        card.style.position = 'relative';
        var layer = document.createElement('div'); layer.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:hidden'; card.appendChild(layer);
        var frames = pv.frames || [], raf = 0, hold = (pv.step || 1) * 0.9 + 0.25;
        var draw = function(){
          var cr = card.getBoundingClientRect(), vr = v.getBoundingClientRect();
          var vw = v.videoWidth, vh = v.videoHeight;
          if(vw && vh){
            var sc = Math.min(vr.width / vw, vr.height / vh), dw = vw * sc, dh = vh * sc;
            var ox = vr.left - cr.left + (vr.width - dw) / 2, oy = vr.top - cr.top + (vr.height - dh) / 2;
            var t = v.currentTime, html = '';
            for(var k = 0; k < frames.length; k++){
              if(Math.abs(frames[k].t - t) > hold) continue;
              frames[k].boxes.forEach(function(b){
                html += '<div style="position:absolute;background:#000;left:' + (ox + b[0] * dw - 4) + 'px;top:' + (oy + b[1] * dh - 4) + 'px;width:' + (b[2] * dw + 8) + 'px;height:' + (b[3] * dh + 8) + 'px"></div>';
              });
            }
            layer.innerHTML = html;
          }
        };
        var paint = function(){ draw(); raf = requestAnimationFrame(paint); };
        raf = requestAnimationFrame(paint);
        ['timeupdate', 'seeked', 'seeking', 'loadedmetadata', 'play', 'pause'].forEach(function(ev){ v.addEventListener(ev, draw); });
        window.addEventListener('resize', draw);
        stopOverlay = function(){ cancelAnimationFrame(raf); window.removeEventListener('resize', draw); };
      }
    }
    if(v) attachVideoSource(v, src);
    lb.querySelector('.crv-lb-cap').textContent = title || '';
    var prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    function close(){
      stopOverlay();
      try{ if(v){ v.pause(); if(v.__hls){ v.__hls.destroy(); v.__hls = null; } v.removeAttribute('src'); v.load(); } }catch(e){}
      lb.classList.remove('open');
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = prevOverflow;
      setTimeout(function(){ lb.remove(); }, 180);
    }
    function onKey(e){ if(e.key === 'Escape') close(); }
    lb.addEventListener('click', function(e){ if(e.target === lb) close(); });
    lb.querySelector('.crv-lb-x').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(function(){ lb.classList.add('open'); });
  }

  var PHOTO_UNDO = new WeakMap();

  function openLightbox(items, index, rtl){
    if(!items.length) return;
    var i = Math.max(0, index);
    var lb = document.createElement('div');
    lb.className = 'crv-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    if(rtl) lb.setAttribute('dir', 'rtl');
    lb.innerHTML = '<div class="crv-lb-card">'
      + '<button type="button" class="crv-lb-x" aria-label="' + S.close + '">✕</button>'
      + '<img class="crv-lb-img" alt="">'
      + (items.length > 1 ? '<button type="button" class="crv-lb-nav crv-lb-prev" aria-label="‹">‹</button><button type="button" class="crv-lb-nav crv-lb-next" aria-label="›">›</button>' : '')
      + '<div class="crv-lb-cap"></div><div class="crv-lb-count"></div>'
      + '<div class="crv-lb-tools"><button type="button" class="crv-lb-cover"></button><button type="button" class="crv-lb-undo" style="display:none"></button></div>'
      + '<div class="crv-lb-draw" style="display:none"></div></div>';
    document.body.appendChild(lb);
    var imgEl = lb.querySelector('.crv-lb-img'), capEl = lb.querySelector('.crv-lb-cap'), countEl = lb.querySelector('.crv-lb-count');
    var coverBtn = lb.querySelector('.crv-lb-cover'), undoBtn = lb.querySelector('.crv-lb-undo'), drawEl = lb.querySelector('.crv-lb-draw');
    coverBtn.textContent = '\u25ad ' + S.cover; undoBtn.textContent = '\u21b6 ' + S.undo;
    var covering = false;
    function setCover(on){
      covering = on; drawEl.style.setProperty('display', on ? 'block' : 'none', 'important');
      coverBtn.textContent = on ? ('\u2713 ' + S.done + ' \u2014 ' + S.coverHelp) : ('\u25ad ' + S.cover);
      coverBtn.classList.toggle('on', on);
      if(on) placeDraw();
    }
    function placeDraw(){
      var r = imgEl.getBoundingClientRect(), c = lb.querySelector('.crv-lb-card').getBoundingClientRect();
      drawEl.style.left = (r.left - c.left) + 'px'; drawEl.style.top = (r.top - c.top) + 'px';
      drawEl.style.width = r.width + 'px'; drawEl.style.height = r.height + 'px';
    }
    function refreshUndo(){ undoBtn.style.display = (items[i].el && PHOTO_UNDO.has(items[i].el) && PHOTO_UNDO.get(items[i].el).length) ? '' : 'none'; }
    coverBtn.addEventListener('click', function(){ setCover(!covering); });
    undoBtn.addEventListener('click', function(){
      var st = items[i].el && PHOTO_UNDO.get(items[i].el);
      if(!st || !st.length) return;
      var prev = st.pop(); items[i].el.setAttribute('src', prev); items[i].src = prev; imgEl.src = prev; refreshUndo();
      if(window.__crvPhotoChanged) window.__crvPhotoChanged();
    });
    var drag = null, band = null;
    function pt(e){ var r = drawEl.getBoundingClientRect(); return { x: Math.max(0, Math.min(r.width, e.clientX - r.left)), y: Math.max(0, Math.min(r.height, e.clientY - r.top)) }; }
    drawEl.addEventListener('pointerdown', function(e){
      e.preventDefault(); try{ drawEl.setPointerCapture(e.pointerId); }catch(x){}
      drag = pt(e); band = document.createElement('div'); band.className = 'crv-lb-band'; band.style.setProperty('display', 'block', 'important'); drawEl.appendChild(band);
    });
    drawEl.addEventListener('pointermove', function(e){
      if(!drag) return; var p = pt(e);
      band.style.left = Math.min(drag.x, p.x) + 'px'; band.style.top = Math.min(drag.y, p.y) + 'px';
      band.style.width = Math.abs(p.x - drag.x) + 'px'; band.style.height = Math.abs(p.y - drag.y) + 'px';
    });
    drawEl.addEventListener('pointerup', function(e){
      if(!drag) return; var p = pt(e), a = drag; drag = null;
      if(band){ band.remove(); band = null; }
      var w = Math.abs(p.x - a.x), h = Math.abs(p.y - a.y);
      if(w < 8 || h < 8) return;
      burnBox(Math.min(a.x, p.x), Math.min(a.y, p.y), w, h);
    });
    function burnBox(x, y, w, h){
      var it = items[i];
      var nw = imgEl.naturalWidth, nh = imgEl.naturalHeight; if(!nw || !nh) return;
      var W = imgEl.clientWidth, H = imgEl.clientHeight, sc = Math.min(W / nw, H / nh);
      var offX = (W - nw * sc) / 2, offY = (H - nh * sc) / 2;
      var rx = Math.max(0, (x - offX) / sc), ry = Math.max(0, (y - offY) / sc), rw = Math.min(nw - rx, w / sc), rh = Math.min(nh - ry, h / sc);
      try{
        var cv = document.createElement('canvas'); cv.width = nw; cv.height = nh;
        var ctx = cv.getContext('2d'); ctx.drawImage(imgEl, 0, 0, nw, nh);
        ctx.fillStyle = '#000'; ctx.fillRect(rx, ry, rw, rh);
        var out = cv.toDataURL('image/jpeg', 0.92);
        if(it.el){
          var st = PHOTO_UNDO.get(it.el) || []; st.push(it.src); PHOTO_UNDO.set(it.el, st);
          it.el.setAttribute('src', out);
        }
        it.src = out; imgEl.src = out; refreshUndo();
        if(window.__crvPhotoChanged) window.__crvPhotoChanged();
      }catch(err){ alert(S.coverFail); }
    }
    function show(){
      if(covering) setCover(false);
      refreshUndo();
      imgEl.src = items[i].src;
      capEl.textContent = items[i].cap || '';
      countEl.textContent = items.length > 1 ? (i + 1) + ' / ' + items.length : '';
    }
    function step(d){ i = (i + d + items.length) % items.length; show(); }
    function close(){
      lb.classList.remove('open');
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = prevOverflow;
      setTimeout(function(){ lb.remove(); }, 180);
    }
    function onKey(e){
      if(e.key === 'Escape') close();
      else if(e.key === 'ArrowRight') step(rtl ? -1 : 1);
      else if(e.key === 'ArrowLeft') step(rtl ? 1 : -1);
    }
    var prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    lb.addEventListener('click', function(e){ if(e.target === lb) close(); });
    lb.querySelector('.crv-lb-x').addEventListener('click', close);
    var prev = lb.querySelector('.crv-lb-prev'), next = lb.querySelector('.crv-lb-next');
    if(prev) prev.addEventListener('click', function(){ step(-1); });
    if(next) next.addEventListener('click', function(){ step(1); });
    document.addEventListener('keydown', onKey);
    // Swipe between this page's photos.
    var sx = null;
    imgEl.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, { passive: true });
    imgEl.addEventListener('touchend', function(e){
      if(sx == null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if(Math.abs(dx) > 40) step((dx < 0 ? 1 : -1) * (rtl ? -1 : 1));
    });
    show();
    requestAnimationFrame(function(){ lb.classList.add('open'); });
  }
})();
